import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bi-dashboard',
  templateUrl: './bi-dashboard.component.html',
  styleUrls: ['./bi-dashboard.component.scss']
})
export class BiDashboardComponent implements OnInit {

    //Graphic1
    assessmentsByMonthDatasets: any[] = [
        { data: [180, 420, 1210, 830], label: 'Assessments by month' }
    ];
    assessmentsByMonthLabel: string[] = ['January', 'February', 'March', 'April'];
    assessmentsByMonthOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    assessmentsByMonthLegend: boolean = true;
    assessmentsByMonthChartType: string = 'bar';

    colors: Array<any> = [
        { // blue
            backgroundColor: '#2d8ac1',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];

    //Graphic2
    assessmentsBySetDatasets: any[] = [
        { data: [3200, 995, 498], label: 'Assessments by type' }
    ];
    assessmentsBySetLabel: string[] = ['General', 'Business', 'Sports'];
    assessmentsBySetOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    assessmentsBySetLegend: boolean = true;
    assessmentsBySetChartType: string = 'bar';

    //Graphic3
    averageResultDatasets: any[] = [
        { data: [100, 350, 450, 1300, 2400, 510, 25 ], label: 'Average result' }
    ];
    averageResultLabel: string[] = ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7'];
    averageResultOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true
    };
    averageResultLegend: boolean = true;
    averageResultChartType: string = 'bar';

  constructor() { }

  ngOnInit() { 
  }

  // events
  public chartClicked(e: any): void {
      console.log(e);
  }

  public chartHovered(e: any): void {
      console.log(e);
  }

}
